<!--
재고입고(등록) 에서 사용되는 상품(1개) 컴포넌트

-->
<template>
    <div class="uk-card-small">

        <!-- 소유자 선택 -->
        <h3>소유자 선택</h3>

        <app-input-search-select
                class="input"

                name="user_id"
                with-hidden-input

                v-model="userId"

                :options="userIdOptions"

                placeholder="입고상품의 소유주를 선택하세요"

                :validate-rules="{required: true}"
                required
                required-layout="label-left"
        > </app-input-search-select>

        <!-- 상품 -->
        <h3>재고상품(<i>{{ items.length }}</i>)</h3>

        <ul class="uk-list uk-list-striped">
            <app-stock-reg-prod
                ref="prods"
                v-for="(prod, index) in items"
                :key="index"
                :index="index"
                :columns="prod"

                :removeButtonDisable="items.length < 2"
                :removeButtonText="removeButtonText"
                :duplicateButtonText="duplicateButtonText"

                v-on:duplicate="duplicate"
                v-on:remove="remove"

                :hscode-options="hscodeOptions"
                :shipping-center-options="shippingCenterOptions"
                :region-currency="regionCurrency"
            > </app-stock-reg-prod>
        </ul>
        


        <!-- 추가버튼 -->
        <div class="uk-text-left">
            <button
                class="uk-button uk-button-black"
                type="button"
                @click="add"
            >
                <span uk-icon="icon: plus-circle"></span>
                {{ addButtonText }}
            </button>

        </div>
    </div>
</template>

<script>
    export default {
        props: {

            addButtonText: {
                type: String,
                default: '상품추가'
            },
            duplicateButtonText: {
                type: String,
                default: '복사'
            },
            removeButtonText: {
                type: String,
                default: '삭제'
            },
            removeConfirm: {
                type: String,
                default: '정말 삭제하겠습니까?'
            },
            lastProdRemoveAlert: {
                type: String,
                default: '마지막 상품을 삭제할 수 없습니다.'
            },

            /**
             * HS코드표 옵션 배열
             */
            hscodeOptions: {
                type: Array,
                default: () => {return [];}
            },

            /**
             * 배송지 옵션 배열
             */
            shippingCenterOptions: {
                type: Array,
                default: () => {return [];}
            },

            /**
             * 지역기본 화폐단위
             */
            regionCurrency: {
                type: String,
            },
            /**
             * 회원사 옵션
             */
            userIdOptions: {
                type: Array,
            },
        },
        data: function () {
            return {
                // 상품정보 배열
                items: [
                ],

                // 회원사 아이디
                userId: null
            };
        },
        computed: {
        },
        watch: {
        },
        mounted: function () {
            // 첫 상품하나 기본 추가
            this.add();

            // 전역에 현재 컴포넌트 등록
            if (! window.vnodes) {
                window.vnodes = {};
            }
            window.vnodes.appStockRegProdList = this;
        },
        methods: {

            /**
             * 상품 추가
             */
            add: function () {
                this.items.push({
                    // 상품정보
                    prod_code: '',
                    vender_code: '',
                    vender_url: '',
                    vender_mall: '',
                    img_url: '',
                    name: '',
                    brand: '',
                    color: '',
                    size: '',
                    type_name: '',
                    hscode: '',
                    unit_price: '',
                    amount: '',
                    memo: '',

                    // 해외오더
                    buy_order_code: '',
                    buy_unit_price: '',
                    shipping_center: '',
                    tracking_no: '',

                });
            },
            /**
             * 복사
             * @param index 선택한 배열 index
             */
            duplicate: function (index) {
                this.items.push($.extend({}, this.items[index]));

                //this.rebindAllProd();
            },
            /**
             * 제거
             * @param index 선택한 배열 index
             */
            remove: function (index) {
                if (! confirm (this.removeConfirm)) {
                    return;
                }

                if (this.items.length <= 1) {
                    alert(this.lastProdRemoveAlert);
                    return;
                }
                //console.log('remove is '+index);
                this.items.splice(index, 1);
                //console.log(this.items);

                //this.rebindAllProd();

            },
            /**
             * 모든 상품요소에 대해서 바인딩을 다시함.
             */
             /*
            rebindAllProd: function () {
                this.$nextTick(function () {
                    this.$refs.prods.forEach(function (prod) {
                        prod.rebind();
                    });
                });

            },
            */
            /**
             * 각 상품 칼럼에 오류메세지를 설정한다.
             * @param errors 오류메세지 배열
             * @param idx 오류난 상품 인덱스
             */
            setErrors: function (errors, idx) {
                _.find(this.$children, function (cmp) {
                    if (cmp.index == idx) { /** 하나는 숫자 하나는 문자열일 수 있기때문에, === 비교안함 */
                        // 메세지
                        _.each(errors, function (msg, key) {
                            if (cmp.$refs[key]) {
                                cmp.$refs[key].setState('error', msg);
                            }
                        });

                        return true;
                    }
                    return false;
                })
                //console.log(idx);
                //console.log(errors);
            }

        }
    }
</script>

<style lang="scss" scoped>
</style>